import { Card } from 'react-bootstrap';
import { COLOR, STYLE } from '../../../config/constraits';
import { useCurrentClient } from '../../auth/api/getCurrentClient';
import { useTranslation } from 'react-i18next';
import ChartShareActions from '../../../components/ChartShareActions';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

interface FeelingResultProps {
    totalAvg: number,
    totalSurveys: number;
}

export default function FeelingResult({ totalAvg, totalSurveys }: FeelingResultProps) {
    const { data: currentClient } = useCurrentClient();
    const { t } = useTranslation('dashboard');

    const feelingchartRef = useRef<HTMLDivElement>(null);

    const isNoSurveys = totalSurveys === 0;
    const bgColor = isNoSurveys
        ? "#F5F5F5" // Gris claro
        : totalAvg < (currentClient?.neutralReference || 4)
            ? COLOR.VERMELL // Rojo
            : totalAvg < (currentClient?.positiveReference || 8)
                ? COLOR.TARONJA // Naranja
                : COLOR.VERD; // Verde

    const textColor = isNoSurveys ? "black" : "white";

    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

    return (
        <div ref={feelingchartRef}> 
        <Card
            style={{
                backgroundColor: bgColor,
                color: textColor,
                border: "none",
                borderRadius: STYLE.BORDER_RADIUS,
                height: "100%",
            }}
                className="p-4 d-flex justify-content-center text-center card"
        >

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4>{t("dashboard:dashboardResultatMitja")}</h4>
                <ChartShareActions
                    chartRef={feelingchartRef}
                    title={t("dashboard:dashboardResultatMitja")}
                    filters={selectedFilters}
                    t={t}
                />

            </div>
            {isNoSurveys ? (
                <p style={{ fontWeight: "800", fontSize: "24px" }}>{t("dashboard:noSurveysSelected")}</p>
            ) : (
                <p style={{ fontWeight: "800", fontSize: "48px" }}>{totalAvg.toFixed(2)}/5</p>
            )}

            <p><b>{t("dashboard:dashboardResultatMitjaComment", { numsurveys: totalSurveys })}</b></p>

            </Card>
        </div>
    );
}
